export default __webpack_public_path__ + "static/media/final-wallet.e1c8b88c.jpg";